import { render, staticRenderFns } from "./BirthdayPicker.vue?vue&type=template&id=471edaba&scoped=true&"
import script from "./BirthdayPicker.vue?vue&type=script&lang=js&"
export * from "./BirthdayPicker.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayPicker.vue?vue&type=style&index=0&id=471edaba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471edaba",
  null
  
)

export default component.exports